import { schema } from 'normalizr';

export const WILDCARD_ENTITY = 'CasetivityEntity';

const createUnionSchema = (entitySchemas: schema.Entity[]) =>
    new schema.Union(Object.assign({}, ...entitySchemas.map(e => ({ [e.key]: e }))), 'entityType');
export default createUnionSchema;
